import React from 'react';
interface Stage {
  number: number;
  title: string;
  description: string;
}
const stages: Stage[] = [{
  number: 1,
  title: 'The Cleansing Waves Slow',
  description: 'The Migrating Motor Complex, which depends on healthy vagal output, loses its rhythm. Food and bacteria that should be swept forward begin to stagnate in the small intestine — which is designed to be largely bacteria-free. The environment shifts.'
}, {
  number: 2,
  title: 'Bacterial Overgrowth Takes Hold (SIBO)',
  description: 'With stagnation comes fermentation. Bacteria from the large intestine migrate upward and colonise the small intestine. They ferment carbohydrates that should have been absorbed, producing gas that distends the intestinal wall. This is the bloat that arrives regardless of what you ate. This is the cramping. And because these bacteria produce methane that further slows intestinal movement, the problem compounds itself — the more backed up things get, the worse the bacterial overgrowth becomes.'
}, {
  number: 3,
  title: 'The Gut Wall Is Damaged (Leaky Gut)',
  description: "Bacterial byproducts attack the tight junctions between intestinal cells — the microscopic seals that keep gut contents inside the gut. When these seals are compromised, food particles, bacterial toxins, and inflammatory compounds leak into the bloodstream. This is where food sensitivities that weren't there five years ago suddenly appear. Where fatigue and brain fog and joint pain enter the picture. The gut problem is no longer just in the gut."
}, {
  number: 4,
  title: 'Systemic Inflammation Becomes Chronic',
  description: "The vagus nerve is the primary regulator of the body's anti-inflammatory system — what researchers call the cholinergic anti-inflammatory pathway. When vagal activity is suppressed, this system loses its brake. Inflammatory cytokines that should be local and short-lived become elevated throughout the body. This is the biological origin of the chronic fatigue, the low-grade anxiety, the sleep disruption, and the generalised feeling of unwellness that so many gut sufferers experience alongside their digestive symptoms. They are not separate conditions. They are downstream consequences of the same upstream failure."
}];
export function StageBreakdown() {
  return <div className="my-12 space-y-8" data-id="element-217">
      {stages.map(stage => <div key={stage.number} className="flex flex-col sm:flex-row gap-6 sm:gap-8 items-start bg-white/50 p-6 rounded-2xl border border-taupe/20" data-id="element-218">
          <div className="flex-shrink-0 flex items-center justify-center w-16 h-16 rounded-full border-2 border-sage text-forest font-serif text-3xl" data-id="element-219">
            {stage.number}
          </div>
          <div data-id="element-220">
            <h3 className="text-xl font-serif font-medium text-forest mb-3" data-id="element-221">
              {stage.title}
            </h3>
            <p className="text-ink/80 leading-relaxed m-0" data-id="element-222">
              {stage.description}
            </p>
          </div>
        </div>)}
    </div>;
}